module.exports = __webpack_public_path__ + "static/media/bg1.ea8ee176.jpg";